export default __webpack_public_path__ + "static/media/orders.f120830d.jpg";